import { withOverlayControls } from '@eventbrite/eds-structure';
import { withMainControls } from '@eventbrite/eds-structure';
import withNotification from './_internal/withNotification';

import EventCard from './EventCard';

export default withMainControls(
    withOverlayControls(withNotification(EventCard)),
);
